import React from "react";
import Conductores from "./Desplegables/Conductores";
import Vehiculos from "./Desplegables/Vehiculos";

export default function FlotaVehicular({
  companyId,
  diagnosisId,
}: {
  companyId: number; //Para cuando se usa el componente por fuera osea solo para hacer el conteo del pesv, cancela la conulta previa de eixstencias
  diagnosisId: number;
}) {
  return (
    <div className="flex flex-col overflow-auto">
      <div className="w-full flex flex-col gap-2">
        {/**El desplegablae de Cantidad de vehiculos */}
        <Vehiculos companyId={companyId} diagnosisId={diagnosisId} />
        {/**El desplegablae de Cantidad de trabajadores y conductires */}
        <Conductores companyId={companyId} diagnosisId={diagnosisId} />{" "}
      </div>
    </div>
  );
}
